import React, { useEffect, useState, useCallback } from 'react'; 
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import GetDistricts from "../../Dropdowns/getAllDistricts";
import GetAllAfso from "../../Dropdowns/getAfsoAll";
import GetFpssIdAll from "../../Dropdowns/getFpsidAll";

const EKYC_tobedone_int = () => {
  const [status, setStatus] = useState('');
  const [loadingGen, setLoadingGen] = useState(false);
  const [loadingGet, setLoadingGet] = useState(false);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingAfso, setLoadingAfso] = useState(false);
  const [district, setDistrict] = useState('');
  const [office, setOffice] = useState('');
  const [fps, setFps] = useState('0'); 
  const [data, setData] = useState([]);
  const [linkVisible, setLinkVisible] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [fpsLoading, setFpsLoading] = useState(false);
  const [noDataMsg, setNoDataMsg] = useState('');
  const [getLinkError, setGetLinkError] = useState(''); 

  const handleDistrictLoading = useCallback((isLoading) => {
    setLoadingDistricts(isLoading);
  }, []);

  const handleAfsoLoading = useCallback((isLoading) => {
    setLoadingAfso(isLoading);
  }, []);

  const onDistrictChange = useCallback((dist) => {
    setDistrict(dist);
    setOffice('');              
    setFps('0');
    setLinkVisible(false);
    setData([]);
    setNoDataMsg('');
    setGetLinkError(''); 
  }, []);

  const onOfficeChange = useCallback((off) => {
    setOffice(off);
    setFps('0');
    setLinkVisible(false);
    setData([]);
    setNoDataMsg('');
    setGetLinkError(''); 
  }, []);

  const onFpsChange = useCallback((selectedFps) => {
    setFps(selectedFps);
    setLinkVisible(false);
    setData([]);
    setNoDataMsg('');
    setGetLinkError(''); 
  }, []);

  const handleFpsLoading = useCallback((isLoading) => {
    setFpsLoading(isLoading);
  }, []);

  const handleGenerate = async () => {
    
    setStatus('');
    setNoDataMsg('');
    setGetLinkError('');

    setLoadingGen(true);
    setLinkVisible(false);
    setData([]);
    setFormVisible(false);
    setDistrict('');
    setOffice('');
    setFps('0');

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/api/ekyc-to-be-done/generate`,
        {},
        { withCredentials: true }
      );

      setStatus(res.data);

      if (
        res.data.includes("Data generated") ||
        res.data.includes("Successfully") ||
        res.data.includes("Please download")
      ) {
        setFormVisible(true);
      } else {
        setFormVisible(false);
      }
    } catch (err) {
      setStatus("Internal Exception");
      setFormVisible(false);
    } finally {
      setLoadingGen(false);
    }
  };

  const handleGetLink = async () => {
    if (!district || district.trim() === '') {
      alert('Please select a district');
      return;
    }

    const selectedDistrict = district;
    const selectedOffice   = office || '';
    const selectedFps      = fps || '0';

    setLoadingGet(true);
    setData([]);
    setLinkVisible(false);
    setNoDataMsg('');
    setGetLinkError(''); 

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL}/api/ekyc-to-be-done/data`,
        {
          params: {
            district: selectedDistrict,
            office:   selectedOffice,
            fpsId:    selectedFps
          },
          withCredentials: true
        }
      );

      if (res.data && res.data.length > 0) {
        setData(res.data);
        setLinkVisible(true);
        setNoDataMsg('');
      } else {
        setNoDataMsg('No Data Found');
        setLinkVisible(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setGetLinkError('Internal Exception');
      setLinkVisible(false);
    }

    setLoadingGet(false);
  };

  const downloadExcel = () => {
    if (data.length === 0) return;

    const displayValues = getDisplayValues();
    
    let title = `EKYC to be done Member Details`;
    
    const parts = [];
    
    if (displayValues.district) parts.push(displayValues.district);
    if (displayValues.office && displayValues.office !== '') parts.push(displayValues.office);
    if (displayValues.fps && displayValues.fps !== '') parts.push(displayValues.fps);
    
    if (parts.length > 0) {
      title += ` in ${parts.join('/')}`;
    }

    const heading =
      `<tr><td colspan="12" style="font-weight:bold; background-color:orange; text-align:center;">${title}</td></tr>`;
    const headerRow =
      `<tr bgcolor="#ff9900" style="font-weight:bold; color:black;" align="center">
        <td>Sl No</td><td>District</td><td>Office</td><td>FPS Id</td><td>RC Id</td>
        <td>Member Id</td><td>Member Name</td><td>Gender</td><td>UID</td>
        <td>Mobile No.</td><td>Scheme Type</td><td>Scheme</td>
      </tr>`;
    const bodyRows = data.map((r, i) => `
      <tr>
        <td>${i + 1}</td>
        <td>${r.district || ''}</td>
        <td>${r.office || ''}</td>
        <td style="mso-number-format:'\\@';">${r.fpsId || ''}</td>
        <td style="mso-number-format:'\\@';">${r.rcId || ''}</td>
        <td style="mso-number-format:'\\@';">${r.memberId || ''}</td>
        <td>${r.memberName || ''}</td>
        <td>${r.gender || ''}</td>
        <td style="mso-number-format:'\\@';">${r.uid || ''}</td>
        <td>${r.mobileNo?.trim() ? r.mobileNo : 'NA'}</td>
        <td>${r.schemeType || ''}</td>
        <td>${r.scheme || ''}</td>
      </tr>`).join('');
    const dateTimeRow =
      `<tr style="background-color: orange; font-weight: bold;">
        <td colspan="12" align="right">Data Time: ${new Date().toLocaleString()}</td>
      </tr>`;

    const blob = new Blob(
      [`<table border="1">${heading}${headerRow}<tbody>${bodyRows}${dateTimeRow}</tbody></table>`],
      { type: 'application/vnd.ms-excel' }
    );
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${title.replace(/\//g, '-')}.xls`;
    a.click();
  };

  const getDisplayValues = () => {
    const displayValues = {
      district: '',
      office: '',
      fps: ''
    };

    if (!district || district === '0' || district.toLowerCase() === 'all') {
      displayValues.district = 'All';
    } else if (district) {
      const districtSelect = document.querySelector('[name="district"]');
      if (districtSelect) {
        const selectedOption = districtSelect.options[districtSelect.selectedIndex];
        displayValues.district = selectedOption ? selectedOption.text : district;
      } else {
        displayValues.district = data[0]?.district || 'District';
      }
    }

    if (!office || office === '0' || office.toLowerCase() === 'all') {
      displayValues.office = 'All';
    } else if (office) {
      const officeSelect = document.querySelector('[name="office"]');
      if (officeSelect) {
        const selectedOption = officeSelect.options[officeSelect.selectedIndex];
        displayValues.office = selectedOption ? selectedOption.text : office;
      } else {
        displayValues.office = data[0]?.office || 'Office';
      }
    }

    if (!fps || fps === '0' || fps.toLowerCase() === 'all') {
      displayValues.fps = 'All';
    } else if (fps) {
      const fpsSelect = document.getElementById('fps_id');
      if (fpsSelect) {
        const selectedOption = fpsSelect.options[fpsSelect.selectedIndex];
        displayValues.fps = selectedOption ? selectedOption.text : fps;
      } else {
        displayValues.fps = fps;
      }
    }

    return displayValues;
  };

  const getLinkDisplayText = () => {
    const displayValues = getDisplayValues();
    
    const parts = [];
    if (displayValues.district) parts.push(displayValues.district);
    if (displayValues.office && displayValues.office !== 'All') parts.push(displayValues.office);
    if (displayValues.fps && displayValues.fps !== 'All') parts.push(displayValues.fps);
    
    let linkText = 'EKYC to be done Member Details';
    if (parts.length > 0) {
      linkText += ` in ${parts.join(' / ')}`;
    } else {
      linkText += ` (All Districts)`;
    }
    
    return linkText;
  };

  return (
    <form>
      <table width="35%" align="center" style={{marginTop:"15px"}}>
        <tbody>
          <tr className="tableheader">
            <td colSpan="2" align="center">EKYC To Be Done Member Details</td>
          </tr>
          <tr>
            <td colSpan="2" align="center">
              <button
                type="button"
                className="button button2"
                onClick={handleGenerate}
                disabled={loadingGen}
              >
                Generate EKYC to be Done Member Details
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {loadingGen && (
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <CircularProgress />
         
        </div>
      )}

      {status && (
        <div
          align="center"
          style={{
            margin: '20px',
            fontWeight: 'bold',
            color: status.includes('Error') || status.includes('Exception') ? 'red' : 'brown',
            textDecoration: 'underline',
            fontSize: '18px'
          }}
        >
          {status}
        </div>
      )}

      {formVisible && (
        <>
          <table width="60%" align="center" style={{ marginTop: '30px' }}>
            <tbody>
              <tr className="tableheader">
                <td colSpan="7" align="center">EKYC To Be Done Member Details</td>
              </tr>
              <tr>
                <td>District</td>
                <td>
                  <GetDistricts
                    value={district}
                    onChange={onDistrictChange}
                    onLoadingChange={handleDistrictLoading}  
                  />
                </td>
                <td>Office</td>
                <td>
                  {district && district !== '' && district !== '0' ? (
                    <GetAllAfso
                      dist_code={district}
                      value={office}
                      onChange={onOfficeChange}
                      onLoadingChange={handleAfsoLoading} 
                    />
                  ) : (
                    <select disabled>
                      <option value=""></option>
                    </select>
                  )}
                </td>
                <td>FPS</td>
                <td>
                  {district && office && district !== '' && office !== '' && 
                   district !== '0' && office !== '0' ? (
                    <GetFpssIdAll
                      dist_code={district}
                      afso_code={office}
                      value={fps}
                      onChange={onFpsChange}
                      onLoadingChange={handleFpsLoading}
                    />
                  ) : (
                    <select disabled>
                      <option value=""></option>
                    </select>
                  )}
                </td>
                <td>
                  <button
                    type="button"
                    className="button button2"
                    onClick={handleGetLink}
                    disabled={loadingGet || fpsLoading || loadingDistricts || loadingAfso}
                  >
                    Get link
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          {getLinkError && (
            <div
              align="center"
              style={{
                margin: '20px',
                fontWeight: 'bold',
                color: 'red',
                textDecoration: 'underline',
                fontSize: '18px'
              }}
            >
              {getLinkError}
            </div>
          )}
        </>
      )}

      {(loadingGet || loadingDistricts || loadingAfso) && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
          <CircularProgress size={30} />
        </div>
      )}

      {formVisible && noDataMsg && (
        <div
          align="center"
          style={{
            margin: '20px',
            fontWeight: 'bold',
            color: 'brown',
            textDecoration: 'underline',
            fontSize: '18px'
          }}
        >
          {noDataMsg}
        </div>
      )}

      {linkVisible && data.length > 0 && (
        <div align="center" style={{ margin: '35px' }}>
          <button
            type="button"
            onClick={downloadExcel}
            style={{
              fontWeight: 'bold',
              color: 'blue',
              textDecoration: 'none',
              cursor: 'pointer',
              background: 'none',
              border: 'none',
              padding: 0,
              fontSize: '16px'
            }}
          >
            {getLinkDisplayText()}
          </button>
        </div>
      )}
    </form>
  );
};

export default EKYC_tobedone_int;




// import React, { useEffect, useState, useCallback } from 'react'; 
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import CircularProgress from '@mui/material/CircularProgress';
// import GetDistrictsRoleBased from '../../Dropdowns/getDistrictsRoleBased';
// import GetAfsoRoleBased from '../../Dropdowns/getAfsoRoleBased';
// import GetFpssId from '../../Dropdowns/getFpsidAll'; 
// const EKYC_tobedone_int = () => {
//   const [status, setStatus] = useState('');
//   const [loadingGen, setLoadingGen] = useState(false);
//   const [loadingGet, setLoadingGet] = useState(false);
//   const [district, setDistrict] = useState('');
//   const [office, setOffice] = useState('');
//   const [fps, setFps] = useState('0'); 
//   const [data, setData] = useState([]);
//   const [linkVisible, setLinkVisible] = useState(false);
//   const [formVisible, setFormVisible] = useState(false);
//   const [fpsLoading, setFpsLoading] = useState(false);
//   const [noDataMsg, setNoDataMsg] = useState('');
//   const [getLinkError, setGetLinkError] = useState(''); 

//   const onDistrictChange = useCallback((dist) => {
//     setDistrict(dist);
//     setOffice('');
//     setFps('0');
//     setLinkVisible(false);
//     setData([]);
//     setNoDataMsg('');
//     setGetLinkError(''); 
//   }, []);

//   const onOfficeChange = useCallback((off) => {
//     setOffice(off);
//     setFps('0');
//     setLinkVisible(false);
//     setData([]);
//     setNoDataMsg('');
//     setGetLinkError(''); 
//   }, []);

//   const onFpsChange = useCallback((selectedFps) => {
//     setFps(selectedFps);
//     setLinkVisible(false);
//     setData([]);
//     setNoDataMsg('');
//     setGetLinkError(''); 
//   }, []);

//   const handleFpsLoading = useCallback((isLoading) => {
//     setFpsLoading(isLoading);
//   }, []);

//   const handleGenerate = async () => {
//     setLoadingGen(true);
//     setLinkVisible(false);
//     setData([]);
//     setFormVisible(false);
//     setDistrict('');
//     setOffice('');
//     setFps('0');
//     setNoDataMsg('');
//     setGetLinkError(''); 
//     try {
//       const res = await axios.post(
//         `${process.env.REACT_APP_URL}/api/ekyc-to-be-done/generate`,
//         {},
//         { withCredentials: true }
//       );
//       setStatus(res.data);
//       if (
//         res.data.includes("Data generated") ||
//         res.data.includes("Successfully") ||
//         res.data.includes("Please download")
//       ) {
//         setFormVisible(true);
//       } else {
//         setFormVisible(false);
//       }
//     } catch {
//       setStatus("Internal Exception");
//       setFormVisible(false);
//     }
//     setLoadingGen(false);
//   };

//   const handleGetLink = async () => {
//     if (!district) return alert('Please select a district');

//     const selectedDistrict = district;
//     const selectedOffice = selectedDistrict === '0' ? '0' : (office || '0');
//     const fpsSelect = document.getElementById('fps_id');
//     const selectedFps = selectedDistrict === '0' ? '0' : (fpsSelect ? fpsSelect.value : '0');

//     setFps(selectedFps);
//     setLoadingGet(true);
//     setData([]);
//     setLinkVisible(false);
//     setNoDataMsg('');
//     setGetLinkError(''); 

//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_URL}/api/ekyc-to-be-done/data`,
//         {
//           params: {
//             district: selectedDistrict,
//             office: selectedOffice,
//             fpsId: selectedFps
//           },
//           withCredentials: true
//         }
//       );
//       if (res.data && res.data.length > 0) {
//         setData(res.data);
//         setLinkVisible(true);
//         setNoDataMsg('');
//       } else {
//         setNoDataMsg('No Data Found');
//         setLinkVisible(false);
//       }
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       setGetLinkError('Internal Exception');
//       setLinkVisible(false);
//     }

//     setLoadingGet(false);
//   };

//   const downloadExcel = () => {
//     if (data.length === 0) return;

//     const displayValues = getDisplayValues();
    
//     let title = `EKYC to be done Member Details`;
    
//     const parts = [];
    
//     if (displayValues.district) {
//       parts.push(displayValues.district);
//     }
    
//     if (displayValues.office && displayValues.office !== '') {
//       parts.push(displayValues.office);
//     }
//     if (displayValues.fps && displayValues.fps !== '') {
//       parts.push(displayValues.fps);
//     }
    
//     if (parts.length > 0) {
//       title += ` in ${parts.join('/')}`;
//     }

//     const heading =
//       `<tr><td colspan="12" style="font-weight:bold; background-color:orange; text-align:center;">${title}</td></tr>`;
//     const headerRow =
//       `<tr bgcolor="#ff9900" style="font-weight:bold; color:black;" align="center">
//         <td>Sl No</td><td>District</td><td>Office</td><td>FPS Id</td><td>RC Id</td>
//         <td>Member Id</td><td>Member Name</td><td>Gender</td><td>UID</td>
//         <td>Mobile No.</td><td>Scheme Type</td><td>Scheme</td>
//       </tr>`;
//     const bodyRows = data.map((r, i) => `
//       <tr>
//         <td>${i + 1}</td>
//         <td>${r.district || ''}</td>
//         <td>${r.office || ''}</td>
//         <td style="mso-number-format:'\\@';">${r.fpsId || ''}</td>
//         <td style="mso-number-format:'\\@';">${r.rcId || ''}</td>
//         <td style="mso-number-format:'\\@';">${r.memberId || ''}</td>
//         <td>${r.memberName || ''}</td>
//         <td>${r.gender || ''}</td>
//         <td style="mso-number-format:'\\@';">${r.uid || ''}</td>
//         <td>${r.mobileNo?.trim() ? r.mobileNo : 'NA'}</td>
//         <td>${r.schemeType || ''}</td>
//         <td>${r.scheme || ''}</td>
//       </tr>`).join('');
//     const dateTimeRow =
//       `<tr style="background-color: orange; font-weight: bold;">
//         <td colspan="12" align="right">Data Time: ${new Date().toLocaleString()}</td>
//       </tr>`;

//     const blob = new Blob(
//       [`<table border="1">${heading}${headerRow}<tbody>${bodyRows}${dateTimeRow}</tbody></table>`],
//       { type: 'application/vnd.ms-excel' }
//     );
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `${title.replace(/\//g, '-')}.xls`;
//     a.click();
//   };

//   const getDisplayValues = () => {
//     const displayValues = {
//       district: '',
//       office: '',
//       fps: ''
//     };

//     if (district === '0') {
//       displayValues.district = 'All';
//     } else if (district && district !== '') {
//       const districtSelect = document.querySelector('[name="district"]');
//       if (districtSelect) {
//         const selectedOption = districtSelect.options[districtSelect.selectedIndex];
//         displayValues.district = selectedOption ? selectedOption.text : 'District';
//       } else {
//         displayValues.district = data[0]?.district || 'District';
//       }
//     }
//     if (office && office !== '' && office !== '0') {
//       const officeSelect = document.querySelector('[name="office"]');
//       if (officeSelect) {
//         const selectedOption = officeSelect.options[officeSelect.selectedIndex];
//         displayValues.office = selectedOption ? selectedOption.text : 'Office';
//       } else {
//         displayValues.office = data[0]?.office || 'Office';
//       }
//     } else if (district === '0') {
//       displayValues.office = 'All';
//     }
//     if (fps && fps !== '' && fps !== '0') {
//       const fpsSelect = document.getElementById('fps_id');
//       if (fpsSelect) {
//         const selectedOption = fpsSelect.options[fpsSelect.selectedIndex];
//         displayValues.fps = selectedOption ? selectedOption.text : 'FPS';
//       } else {
//         displayValues.fps = fps;
//       }
//     } else if (district === '0') {
//       displayValues.fps = 'All';
//     }

//     return displayValues;
//   };

//   const getLinkDisplayText = () => {
//     const displayValues = getDisplayValues();
    
//     const parts = [];
//     if (displayValues.district) parts.push(displayValues.district);
//     if (displayValues.office) parts.push(displayValues.office);
//     if (displayValues.fps) parts.push(displayValues.fps);
    
//     let linkText = 'EKYC to be done Member Details';
//     if (parts.length > 0) {
//       linkText += ` in ${parts.join('/')}`;
//     }
    
//     return linkText;
//   };

//   return (
//     <form>
//       <table width="35%" align="center" style={{marginTop:"15px"}}>
//         <tbody>
//           <tr style={{ backgroundColor: 'black', color: 'white', fontWeight: 'bold' }}>
//             <td colSpan="2" align="center">EKYC To Be Done Member Details</td>
//           </tr>
//           <tr>
//             <td colSpan="2" align="center">
//               <button
//                 type="button"
//                 className="button button2"
//                 onClick={handleGenerate}
//                 disabled={loadingGen}
//               >
//                 Generate EKYC to be Done Member Details
//               </button>
//             </td>
//           </tr>
//         </tbody>
//       </table>

//       {loadingGen && (
//         <div style={{ textAlign: 'center', marginTop: '30px' }}>
//           <CircularProgress />
//           <div style={{fontWeight:'bold', color:'brown',marginTop:'20px', fontSize: '18px'}}>Generating data, please wait..</div>
//         </div>
//       )}

//       {status && (
//         <div
//           align="center"
//           style={{
//             margin: '20px',
//             fontWeight: 'bold',
//             color: status.includes('Error') ? 'red' : 'brown',
//             textDecoration: 'underline',
//             fontSize: '18px'
//           }}
//         >
//           {status}
//         </div>
//       )}

//       {formVisible && (
//         <>
//           <table width="60%" align="center" style={{ marginTop: '30px' }}>
//             <tbody>
//               <tr style={{ backgroundColor: 'black', color: 'white', fontWeight: 'bold' }}>
//                 <td colSpan="7" align="center">EKYC To Be Done Member Details</td>
//               </tr>
//               <tr>
//                 <td>District</td>
//                 <td>
//                   <GetDistrictsRoleBased
//                     value={district}
//                     onChange={onDistrictChange}
//                   />
//                 </td>
//                 <td>Office</td>
//                 <td>
//                   <GetAfsoRoleBased
//                     dist_code={district}
//                     value={office}
//                     onChange={onOfficeChange}
//                   />
//                 </td>
//                 <td>FPS</td>
//                 <td>
//                   {district && office && district !== '0' ? (
//                     <GetFpssId
//                       dist_code={district}
//                       afso_code={office}
//                       value={fps}
//                       onChange={onFpsChange}
//                       onLoadingChange={handleFpsLoading}
//                     />
//                   ) : (
//                     <select disabled>
//                       <option>Select</option>
//                     </select>
//                   )}
//                 </td>
//                 <td>
//                   <button
//                     type="button"
//                     className="button button2"
//                     onClick={handleGetLink}
//                     disabled={!district || loadingGet || fpsLoading}
//                   >
//                     {loadingGet ? 'Loading...' : 'Get Link'}
//                   </button>
//                 </td>
//               </tr>
//             </tbody>
//           </table>

//           {getLinkError && (
//             <div
//               align="center"
//               style={{
//                 margin: '20px',
//                 fontWeight: 'bold',
//                 color: 'red',
//                 textDecoration: 'underline',
//                 fontSize: '18px'
//               }}
//             >
//               {getLinkError}
//             </div>
//           )}
//         </>
//       )}

//       {loadingGet && (
//         <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
//           <CircularProgress size={30} />
//         </div>
//       )}

//       {formVisible && noDataMsg && (
//         <div
//           align="center"
//           style={{
//             margin: '20px',
//             fontWeight: 'bold',
//             color: 'brown',
//             textDecoration: 'underline',
//             fontSize: '18px'
//           }}
//         >
//           {noDataMsg}
//         </div>
//       )}

//       {linkVisible && data.length > 0 && (
//         <div align="center" style={{ margin: '35px' }}>
//           <button
//             type="button"
//             onClick={downloadExcel}
//             style={{
//               fontWeight: 'bold',
//               color: 'blue',
//               textDecoration: 'none',
//               cursor: 'pointer',
//               background: 'none',
//               border: 'none',
//               padding: 0,
//               fontSize: '16px'
//             }}
//           >
//             {getLinkDisplayText()}
//           </button>
//         </div>
//       )}
//     </form>
//   );
// };

// export default EKYC_tobedone_int;
